import React from 'react';
import notFindIcon from '../../assets/images/pic-pccaddie.svg';

const NotFind: React.FC<{
  title?: string;
  description?: string;
  displayIcon?: boolean;
}> = ({
  title = 'Keine Informationen gefunden.',
  description = 'Keine Informationen zur Anzeige verfügbar. Bitte versuchen Sie es später erneut.',
  displayIcon = false,
}) => {
  return (
    <div className="text-center flex flex-col items-center">
      {!displayIcon && <img width={280} src={notFindIcon} alt="404" />}
      <h1 className="text-xl font-medium mt-4">{title}</h1>
      <p className="text-gray-500 text-xs">{description}</p>
    </div>
  );
};

export default NotFind;
